'use client';

import { SquareCheck, Trash2 } from 'lucide-react';

interface NotificationsWidgetProps {
  className?: string;
}

export function NotificationsWidget({ className }: NotificationsWidgetProps) {
  return (
    <div className={className}>
      <div className="w-72 mx-auto">
        {/* Header */}
        <div className="flex items-center gap-2 px-3 py-2 bg-white border border-[#e4e4e7] rounded-t-md">
          <span className="text-sm font-semibold text-[#0a0a0a]">Notifications</span>
          <span className="w-4 h-4 bg-violet-500 text-white text-[10px] font-bold flex items-center justify-center rounded">
            1
          </span>
        </div>

        {/* Nueva notificación (sobresale) */}
        <div className="relative bg-white border-x border-[#e4e4e7]">
          <div className="mx-[-12px] px-4 py-3 bg-violet-50 rounded-md border border-violet-200 shadow-[0_2px_12px_rgba(139,92,246,0.15)]">
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-[#0a0a0a] truncate">Contract completed</p>
                <p className="text-xs text-[#52525b] mt-0.5 truncate">
                  All parties have signed "Financing..."
                </p>
                <span className="text-[11px] text-violet-600 font-medium">now</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <div className="w-2 h-2 rounded-full bg-violet-500" />
                <div className="flex items-center border border-gray-300 rounded shadow-sm bg-white">
                  <button className="w-6 h-6 flex items-center justify-center">
                    <SquareCheck size={12} className="text-gray-500" />
                  </button>
                  <button className="w-6 h-6 flex items-center justify-center">
                    <Trash2 size={12} className="text-gray-500" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Notificación: Pedro Ruiz */}
        <div className="px-3 py-2 bg-white border-x border-b border-[#e4e4e7]">
          <p className="text-xs font-medium text-[#0a0a0a] truncate">Contract signed</p>
          <p className="text-[11px] text-[#71717a] mt-0.5 truncate">
            Pedro Ruiz has signed "Financing..."
          </p>
          <span className="text-[10px] text-[#71717a]">1m</span>
        </div>

        {/* Notificación: María García */}
        <div className="px-3 py-2 bg-white border-x border-b border-[#e4e4e7]">
          <p className="text-xs font-medium text-[#0a0a0a] truncate">Contract signed</p>
          <p className="text-[11px] text-[#71717a] mt-0.5 truncate">
            María García has signed "Financing..."
          </p>
          <span className="text-[10px] text-[#71717a]">3m</span>
        </div>

        {/* Notificación: Payment received */}
        <div className="px-3 py-2 bg-white border-x border-b border-[#e4e4e7] rounded-b-lg">
          <p className="text-xs font-medium text-[#0a0a0a] truncate">Payment received</p>
          <p className="text-[11px] text-[#71717a] mt-0.5 truncate">€15,000 from Carlos Martínez</p>
          <span className="text-[10px] text-[#71717a]">12m</span>
        </div>

        {/* Stacked cards */}
        <div className="mx-3 h-1.5 bg-[#f5f5f5] border-x border-b border-[#e4e4e7] rounded-b" />
        <div className="mx-5 h-1.5 bg-[#ebebeb] border-x border-b border-[#e4e4e7] rounded-b" />
      </div>
    </div>
  );
}

export default NotificationsWidget;
